import { AppShell, Burger, Button, Group, NavLink, ScrollArea, Stack, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Outlet, useLocation } from 'react-router-dom'
import Message from '../../i18n/Message'
import { signOut } from '../../store/authActionCreators'
import IdleGuard from '../shared/IdleGuard'

const AGENT_NAV = [
  { to: '/agent', label: 'nav_dashboard', end: true },
  { to: '/agent/customers', label: 'nav_customers' },
  { to: '/agent/applications', label: 'nav_applications' },
  { to: '/agent/repayments', label: 'nav_repayments' },
]

const ADMIN_NAV = [
  { to: '/admin', label: 'nav_dashboard', end: true },
  { to: '/admin/applications', label: 'nav_applications' },
  { to: '/admin/customers', label: 'nav_customers' },
  { to: '/admin/loans', label: 'nav_loans' },
  { to: '/admin/payments', label: 'nav_payments' },
  { to: '/admin/overdue', label: 'nav_overdue' },
  { to: '/admin/reports', label: 'nav_reports' },
  { to: '/admin/products', label: 'nav_products' },
  { to: '/admin/agents', label: 'nav_agents', superOnly: true },
  { to: '/admin/audit', label: 'nav_audit' },
  { to: '/admin/settings', label: 'nav_settings' },
]

function Shell({ nav, home }) {
  const [opened, { toggle, close }] = useDisclosure()
  const dispatch = useDispatch()
  const user = useSelector((s) => s.auth.user)
  const location = useLocation()
  const items = nav.filter((n) => !n.superOnly || user?.role === 'super_admin')
  const isActive = (n) => (n.end ? location.pathname === n.to : location.pathname.startsWith(n.to))

  return (
    <AppShell header={{ height: 56 }} navbar={{ width: 232, breakpoint: 'md', collapsed: { mobile: !opened } }} padding="md" className="app">
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between" wrap="nowrap">
          <Group gap="sm" wrap="nowrap">
            <Burger opened={opened} onClick={toggle} hiddenFrom="md" size="sm" aria-label="Menu" />
            <Text component={Link} to={home} fw={600} size="lg" ff="var(--mantine-font-family-headings)" c="dark" td="none">
              <Message id="app_name" />
            </Text>
          </Group>
          <Group gap="sm" wrap="nowrap">
            <Text size="sm" c="dimmed" visibleFrom="sm">
              {user?.name}
            </Text>
            <Button variant="default" size="xs" onClick={() => dispatch(signOut())}>
              <Message id="sign_out" />
            </Button>
          </Group>
        </Group>
      </AppShell.Header>
      <AppShell.Navbar p="sm">
        <ScrollArea>
          <Stack gap={2}>
            {items.map((n) => (
              <NavLink key={n.to} component={Link} to={n.to} active={isActive(n)} onClick={close} label={<Message id={n.label} />} style={{ minHeight: 44 }} />
            ))}
          </Stack>
        </ScrollArea>
      </AppShell.Navbar>
      <AppShell.Main>
        <Outlet />
        <IdleGuard />
      </AppShell.Main>
    </AppShell>
  )
}

export const AgentShell = () => <Shell nav={AGENT_NAV} home="/agent" />
export const AdminShell = () => <Shell nav={ADMIN_NAV} home="/admin" />
